// Simple version that only handles grant/grants
export function applyTerminology(text: string): string {
  if (process.env.NEXT_PUBLIC_USE_GIFT_TERMINOLOGY !== "true" || !text) {
    return text;
  }

  return text.replace(/\b(grant|grants|granted)\b/gi, (match) => {
    const lower = match.toLowerCase();

    let replacement = "";
    if (lower === "grant") replacement = "gift";
    else if (lower === "grants") replacement = "gifts";
    else if (lower === "granted") replacement = "gifted";

    if (match === match.toUpperCase()) return replacement.toUpperCase();
    if (match[0] === match[0].toUpperCase()) {
      return replacement[0].toUpperCase() + replacement.slice(1);
    }
    return replacement;
  });
}
